import { PrimaryButton } from "@/ui/buttons/Button";
import { Radio, SearchInput } from "@/ui/inputs/Input";
import React, { useEffect, useRef, useState } from "react";
import useTableService from "../useTableServerSide";
import moment from "moment";
import axios from "axios";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import Footer from "../Footer";
import { ActualizarOrdenCompra } from "./modalActualizarOrdenCompra";
export default function TablaOrdenCompra(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const idefiscal = localStorage.getItem("idefiscal");
  const espiritu = localStorage.getItem("espiritu");
  const post = localStorage.getItem("post");
  const ip = localStorage.getItem("ip");
  const mac = localStorage.getItem("mac");
  const idusuario = localStorage.getItem("idusuario");
  const searchTimeoutRef = useRef(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [ordencompra, setOrdencompra] = useState();
  const [cord, setCord] = useState();
  const [detallecuenta, setDetalleCuenta] = useState([]);
  const [detalle, setDetalle] = useState([]);
  const [facturas, setFacturas] = useState();
  const [proveedor, setProveedor] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [tipo, setTipo] = useState("compra");
  const [operacion, setOperacion] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [totales, setTotales] = useState({
    total: 0,
    totalCompras: 0,
    totalServicios: 0,
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const headCells = [
    {
      id: "id",
      label: "CODIGO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "razonsocial",
      label: "RAZON SOCIAL",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "concepto",
      label: "CONCEPTO",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "fecha",
      label: "FECHA",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const cardsData = [
    {
      title: "TOTAL",
      value: totales.total || 0,
      color: "#053160",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
    {
      title: "Total de Compras",
      value: totales.totalCompras || 0,
      color: "#76b8e8",
      icon: "fas fa-toggle-on fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
    {
      title: "Total de servicios",
      value: totales.totalServicios || 0,
      color: "#ca4117",
      icon: "fas fa-toggle-off fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
  ];

  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };
  const buscarCompras = () => {
    setLoading(true);
    const tipoCompra = tipo === "compra" ? 0 : 1;
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      tipo: tipoCompra,
      efi: idefiscal,
    };
    const endpoint = `${op.conexion}/api/comprasAlmacen/solicitudesdecompras`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          const { rows, count, totales } = response.data;
          setRecords(rows);
          setTotalRecords(count);
          setTotales({
            total: totales.total,
            totalCompras: totales.compra,
            totalServicios: totales.servicio,
          });
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  };
  const buscarSolicitudCompra = async ({ idCompra }) => {
    setLoading(true);
    const tipoCompra = tipo === "compra" ? 0 : 1;
    const orden = tipo === "compra" ? "idordencompra" : "idordenservicio";
    try {
      const resCompra = await axios.get(
        `${op.conexion}/api/comprasAlmacen/selectordencompra?codigo=${idCompra}&tipo=${orden}&idefiscal=${idefiscal}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (!resCompra.data || resCompra.data.length < 0) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message || "Error al cargar la información",
          icono: "error",
        });
        return;
      }
      const dataCompra = resCompra.data[0];
      setOrdencompra(dataCompra);

      const resCoordinacion = await axios.get(
        `${op.conexion}/api/presupuesto/consultarunidadejecutora?id=${dataCompra.idcordinacion}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataCoordinacion = resCoordinacion.data;
      setCord(dataCoordinacion);
      const resProveedor = await axios.get(
        `${op.conexion}/api/consulta/modeli?campos=*&id=${dataCompra.idproveedor}&nomtab=proveedor&nomid=idproveedor`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataProveedor = resProveedor.data;
      setProveedor(dataProveedor);
      const resDetalle = await axios.get(
        `${op.conexion}/api/comprasAlmacen/selectdetalle?nomtab=ordencompradetalle&nomid=${orden}&id=${idCompra}&nomid2=idefiscal&id2=${idefiscal}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataDetalle = resDetalle.data;
      setDetalle(dataDetalle);
      const resFactura = await axios.get(
        `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*, codoperacion AS numoperacion&nomtab=facturaxorden&condi=idordencompra=${idCompra} AND idefiscal = ${idefiscal} AND tipoorden=${tipoCompra}&orden=idfacturaxorden`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataFactura = resFactura.data;
      setFacturas(dataFactura);
      const resDetalleCuenta = await axios.get(
        `${op.conexion}/api/comprasAlmacen/selectdetallecuenta?id=${idCompra}&idefiscal=${idefiscal}&tipo=${tipoCompra}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataDetalleCuenta = resDetalleCuenta.data;
      setDetalleCuenta(dataDetalleCuenta);
      setShowModal(true);
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message || "Error al cargar la información",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const imprimir = ({ idCompra }) => {
    try {
      const elaborado = post.login;
      const reporte =
        parseInt(espiritu) === 0
          ? "ForOrdenCompraPrePaez"
          : "ForOrdenCompraPre";
      const condicion = `${
        tipo === "compra"
          ? `S.IdOrdenCompra=${idCompra}`
          : `S.IdOrdenServicio=${idCompra}`
      } AND S.IDEFISCAL = ${idefiscal} and D.IDEFISCAL = ${idefiscal}`;
      const condicion1 = `mov.IdOrdenCompra=${idCompra} and mov.IDEFISCAL=${idefiscal} AND cta.IDEFISCAL = ${idefiscal} and tipo = ${tipo === "compra" ? 0 : 1}`;
      window.open(
        `${op.reportes}/comprasyalmacen?reporte=${reporte}&CONDICION=${condicion}&CONDICION1=${condicion1}&ELABORADO=${elaborado}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };
  const parametros = ({ ope, id }) => {
    setOperacion(ope);
    if (parseInt(ope) > 1) {
      buscarSolicitudCompra({
        idCompra: id,
      });
    } else {
      setShowModal(true);
    }
  };
  const cerrar = () => {
    props.setTabla(0);
  };

  useEffect(() => {
    const cleanup = buscarCompras();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState, tipo]);

  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", height: "90vh" }}
    >
      <div className="row g-3 mb-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            style={{ borderRadius: 4 }}
            className="col-12 col-sm-4 col-xl"
          >
            <div
              className="card h-100 border-0 rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: card.color,
                color: "white",
                transition: "transform 0.3s, box-shadow 0.3s",
                borderRadius: 15,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.05)",
                }}
              ></div>

              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <span
                      className="text-uppercase small fw-bold opacity-75"
                      style={{ letterSpacing: "2px", fontSize: "1rem" }}
                    >
                      {card.title}
                    </span>
                    <h2
                      className="fw-bold mb-0 mt-1"
                      style={{ fontSize: "2.2rem" }}
                    >
                      {card.value}
                    </h2>
                  </div>
                  <i
                    className={card.icon}
                    style={{ color: card.iconColor }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="row g-4">
        <div className="col-12">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-header azulGradiant text-white d-flex justify-content-between">
              <h5 className="mb-0 fw-bold text-uppercase">
                Solicitudes de Compras
              </h5>
              <a
                type="button"
                className="text-light fw-bold fs-6"
                onClick={cerrar}
                style={{ cursor: "pointer" }}
              >
                <i className="fas fa-times ms-2" />
              </a>
            </div>
            <div className="card-body p-0 m-0">
              <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
                <div className="col-4 m-0 p-0 position-relative">
                  <SearchInput
                    className="search-input pe-4"
                    value={searchInput}
                    onChange={handleSearch}
                  />
                </div>
                <div className="col-2 mx-0 px-0 d-flex py-auto my-auto">
                  <Radio
                    label="Compra"
                    id="customRadioInline4"
                    name="customRadioInline"
                    value="compra"
                    defaultChecked={tipo === "compra"}
                    onChange={(e) => setTipo(e.target.value)}
                  />
                  <Radio
                    label="Servicio"
                    id="customRadioInline5"
                    name="customRadioInline"
                    defaultChecked={tipo === "servicio"}
                    value="servicio"
                    onChange={(e) => setTipo(e.target.value)}
                  />
                </div>
                <div
                  onClick={() =>
                    parametros({
                      ope: 1,
                      id: "",
                    })
                  }
                  className="col-aut mx-2 p-0"
                >
                  <PrimaryButton icon="fa-plus m-0 p-0" />
                </div>
              </div>
              <section className="col-12 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {records &&
                      records.map((item, index) => (
                        <tr key={index} style={{ padding: "0" }}>
                          <td
                            style={{
                              fontSize: "12px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.idordencompra !== null
                              ? item.idordencompra
                              : item.idordenservicio}
                          </td>
                          <td
                            style={{
                              width: "auto",
                              fontSize: "12px",
                              textAlign: "left",
                            }}
                          >
                            {item.razonsocial}
                          </td>
                          <td
                            style={{
                              width: "auto",
                              fontSize: "12px",
                              textAlign: "left",
                            }}
                          >
                            {item.concepto}
                          </td>
                          <td
                            style={{
                              width: "auto",
                              fontSize: "12px",
                              textAlign: "center",
                            }}
                          >
                            {moment.utc(item.fecha).format("DD/MM/YYYY")}
                          </td>
                          <td
                            style={{
                              width: "155px",
                              fontSize: "12px",
                              textAlign: "center",
                            }}
                          >
                            <button
                              onClick={() =>
                                parametros({
                                  ope: 4,
                                  id:
                                    tipo === "compra"
                                      ? item.idordencompra
                                      : item.idordenservicio,
                                })
                              }
                              className="btn btn-sm btn-info rounded-circle mx-1"
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                            <button
                              onClick={() =>
                                parametros({
                                  ope: 2,
                                  id:
                                    tipo === "compra"
                                      ? item.idordencompra
                                      : item.idordenservicio,
                                })
                              }
                              className="btn btn-sm btn-warning rounded-circle mx-1"
                            >
                              <i className="fa fa-edit"></i>
                            </button>
                            <button
                              onClick={() =>
                                parametros({
                                  ope: 3,
                                  id:
                                    tipo === "compra"
                                      ? item.idordencompra
                                      : item.idordenservicio,
                                })
                              }
                              className="btn btn-sm btn-danger rounded-circle mx-1"
                            >
                              <i className="fa fa-trash-alt"></i>
                            </button>
                            <button
                              onClick={() =>
                                imprimir({
                                  idCompra:
                                    tipo === "compra"
                                      ? item.idordencompra
                                      : item.idordenservicio,
                                })
                              }
                              className="btn btn-sm btn-primary rounded-circle mx-1"
                            >
                              <i className="fa fa-print"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </section>
            </div>
          </div>
        </div>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <ActualizarOrdenCompra
        show={showModal}
        declaWeb={false}
        ip={ip}
        mac={mac}
        idusuario={idusuario}
        ordencompra={ordencompra}
        cord={cord}
        detallecuenta={detallecuenta}
        detallecuentas={[]}
        facturas={facturas}
        detalle={detalle}
        proveedor={proveedor}
        operacion={operacion}
        servicio={tipo === "servicio"}
        onHideRenderizar={() => {
          setShowModal(false);
          buscarCompras();
        }}
        onHideCancela={() => setShowModal(false)}
      />
      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
